import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 12\" id=\"icon-pause\"><path d=\"M1.154 12h-1V1.5h1V12Zm6 0h-1V1.5h1V12Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol